import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Pagination from '@src/components/navigation/Pagination'
import PageHeader from '@src/components/headers/PageHeader'
import OrderList from '@src/components/order/list/OrderList'
import useGetVendorOrdersQuery from '@src/hooks/queries/order/useGetVendorOrdersQuery'
import { useState } from 'react'
import useGetVendorOrderItemsQuery from '@src/hooks/queries/order/useGetVendorOrderItemsQuery'

const OrderListPage = () => {
	const [currentPage, setCurrentPage] = useState(1)
	const itemPerPage = 20
	const { data: totalNumRes } = useGetVendorOrderItemsQuery(
		{ getTotal: true, status: 'published' },
		{ enabled: true, retry: false, cacheTime: 0, keepPreviousData: true },
	)
	const totalNum = totalNumRes?.data?.count

	return (
		<Block>
			<PageHeader title="주문 조회" />
			<OrderList itemPerPage={itemPerPage} currentPage={currentPage} />
			<Pagination
				itemPerPage={itemPerPage}
				totalItem={(totalNum && parseInt(totalNum, 10)) || 1}
				currPage={currentPage}
				onChangePage={(page: number) => {
					setCurrentPage(page)
				}}
				css={css`
					width: 400px;
				`}
			/>
		</Block>
	)
}

const Block = styled.div`
	width: 100%;
	margin: auto;
	height: 100%;
	padding-left: 8.2rem;
	padding-right: 3rem;
	padding-bottom: 3rem;
	background-color: #f8f9fc;
	overflow-y: scroll;
`

export default OrderListPage
